/* Waka — menu hamburguesa en celular, saltos a secciones y galeria de producto en carrusel. */
(function(){
  var MQ = '(max-width:749px)';
  function isMobile(){ return window.matchMedia && window.matchMedia(MQ).matches; }
  function panel(){ return document.getElementById('menuPanel'); }
  function scrim(){ return document.getElementById('scrim'); }

  function closeAll(){
    var ps = document.querySelectorAll('.panel.on');
    for(var i=0;i<ps.length;i++){ ps[i].classList.remove('on'); }
    var s = scrim();
    if(s) s.classList.remove('on');
    document.body.style.overflow = '';
    var b = document.getElementById('wkMenuBtn');
    if(b) b.setAttribute('aria-expanded','false');
  }
  function openMenu(){
    var p = panel(); if(!p) return;
    var ps = document.querySelectorAll('.panel.on');
    for(var i=0;i<ps.length;i++){ ps[i].classList.remove('on'); }
    p.classList.add('on');
    var s = scrim();
    if(s) s.classList.add('on');
    document.body.style.overflow = 'hidden';
    var b = document.getElementById('wkMenuBtn');
    if(b) b.setAttribute('aria-expanded','true');
  }

  /* la hamburguesa abre y cierra. Se toma el clic antes que cualquier otro guion. */
  document.addEventListener('click', function(e){
    if(!e.target.closest) return;
    var btn = e.target.closest('#wkMenuBtn, .menu-btn');
    if(!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var p = panel();
    if(p && p.classList.contains('on')) closeAll(); else openMenu();
  }, true);

  /* ---- saltos a una seccion de la portada (computador y celular) ---- */
  function headerH(){
    var h = document.getElementById('shopify-section-header');
    return h ? h.getBoundingClientRect().height + 12 : 90;
  }
  function jump(hash){
    var el = null;
    try { el = document.querySelector(hash); } catch(err){ el = null; }
    if(!el) return false;
    var y = el.getBoundingClientRect().top + window.pageYOffset - headerH();
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
    if(history.replaceState) history.replaceState(null, '', hash);
    return true;
  }
  document.addEventListener('click', function(e){
    if(!e.target.closest) return;
    var a = e.target.closest('a[href]');
    if(!a) return;
    if(a.target === '_blank' || a.hasAttribute('download')) return;
    var u;
    try { u = new URL(a.getAttribute('href'), location.href); } catch(err){ return; }
    if(u.origin !== location.origin || !u.hash) return;
    var samePath = u.pathname.replace(/\/$/,'') === location.pathname.replace(/\/$/,'');
    var sameQuery = u.search === location.search;
    var inMenu = !!a.closest('#menuPanel');
    if(!samePath || !sameQuery){
      if(inMenu) closeAll();
      return; /* deja que el navegador cargue la pagina con su filtro */
    }
    if(inMenu) closeAll();
    if(jump(u.hash)) e.preventDefault();
  });
  window.addEventListener('load', function(){
    if(location.hash && location.hash.length > 1){ setTimeout(function(){ jump(location.hash); }, 240); }
  });

  /* cerrar el panel de celular: velo, boton X, un link del menu, o clic fuera */
  document.addEventListener('click', function(e){
    var p = panel();
    if(!p || !p.classList.contains('on')) return;
    if(!e.target.closest) return;

    if(e.target.closest('#scrim') || e.target.closest('#menuPanel [data-close]')){ closeAll(); return; }

    var search = e.target.closest('#menuPanel [data-mm-search]');
    if(search){
      var sb = document.getElementById('wkSearchBtn');
      e.preventDefault(); closeAll();
      if(sb) setTimeout(function(){ sb.click(); }, 120);
      return;
    }
    var cart = e.target.closest('#menuPanel [data-mm-cart]');
    if(cart){
      var cb = document.getElementById('wkCartBtn');
      e.preventDefault(); closeAll();
      if(cb) setTimeout(function(){ cb.click(); }, 120);
      return;
    }
    if(e.target.closest('#menuPanel a[href]')){ closeAll(); return; }

    if(!e.target.closest('#menuPanel')) closeAll();
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closeAll();
  });

  /* ---- galeria del producto: una foto a la vez con flechas ---- */
  function initGal(){
    if(!isMobile()) return;
    var gal = document.querySelector('.pdp .gal-grid');
    if(!gal || gal.getAttribute('data-mob')) return;
    var cells = gal.querySelectorAll('.gcell');
    if(!cells.length) return;
    gal.setAttribute('data-mob','1');

    var wrap = document.createElement('div');
    wrap.className = 'gal-mob';
    gal.parentNode.insertBefore(wrap, gal);
    wrap.appendChild(gal);
    if(cells.length < 2) return;

    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'gm-arrow prev';
    prev.setAttribute('aria-label','Foto anterior'); prev.innerHTML = '&#8592;';
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'gm-arrow next';
    next.setAttribute('aria-label','Foto siguiente'); next.innerHTML = '&#8594;';
    var count = document.createElement('div');
    count.className = 'gm-count';
    wrap.appendChild(prev); wrap.appendChild(next); wrap.appendChild(count);

    function step(){ return gal.clientWidth || wrap.clientWidth || 1; }
    function idx(){ return Math.round(gal.scrollLeft / step()); }
    function sync(){ count.textContent = (Math.min(idx()+1, cells.length)) + ' / ' + cells.length; }
    prev.addEventListener('click', function(){
      var i = idx() - 1; if(i < 0) i = cells.length - 1;
      gal.scrollTo({left: i * step(), behavior: 'smooth'});
    });
    next.addEventListener('click', function(){
      var i = idx() + 1; if(i > cells.length - 1) i = 0;
      gal.scrollTo({left: i * step(), behavior: 'smooth'});
    });
    var t = null;
    gal.addEventListener('scroll', function(){ clearTimeout(t); t = setTimeout(sync, 70); }, {passive:true});
    sync();
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGal);
  else initGal();
  window.addEventListener('resize', initGal);
  document.addEventListener('shopify:section:load', initGal);
})();
